import { JsonObject } from 'json2typescript';
import { IdAndName } from '@models/configuration/marketplace/id-and-name-model';

@JsonObject('StoreGroup')
export class StoreGroup extends IdAndName {}
